import React, { PureComponent } from 'react'
import storeService from '../../api/services/storeService'
import Metatags from '../../components/shared/Metatags/Metatags'
import StoreNotFound from './StoreNotFound'
import MenuNotFound from './MenuNotFound'
import StoreNotInGeo from './StoreNotInGeo'
import CustomStoreError from './CustomStoreError'
import StoreError from 'api/StoreError'
import { AxiosResponse } from 'axios'

type Meta = {
  og_title?: string,
  og_description?: string,
  og_image?: string,
  og_image_secure_url?: string,
}

type StoreMeta = {
  name: string,
  message: string,
  cover_photo_social: string,
}

interface Props {
  storeId: string,
  error: StoreError,
  toggleGeolocationModal: () => void,
}

interface State {
  meta: Meta
}

class StoreErrorPage extends PureComponent<Props, State> {
  state = {
    meta: {}
  }

  openViaBranch() {
    storeService.openViaBranch({ storeId: this.props.storeId, storeSource: 'HAUSMART' })
  }

  async componentDidMount() {
    if (!this.props.error.isNotFound) {
      const resp: AxiosResponse<StoreMeta> = await storeService.getStoreMeta(this.props.storeId)
      const meta = {
        og_title: resp.data.name,
        og_description: resp.data.message,
        og_image: resp.data.cover_photo_social,
        og_image_secure_url: resp.data.cover_photo_social
      }
      this.setState({ meta })
    }
  }

  render() {
    const {
      error: { message, isNotGeo, isNotFound },
      toggleGeolocationModal
    } = this.props
    const storeId = this.props.storeId
    const isZeroTouch = message.indexOf('Menu') > -1
    return (
      <>
        <Metatags {...this.state.meta} />
        {isNotFound && (isZeroTouch ? <MenuNotFound {...{ response: message }} /> : <StoreNotFound {...{ response: message }} />)}
        {isNotGeo && (
          <StoreNotInGeo
            {... {
              storeId: storeId,
              openViaBranch: this.openViaBranch,
              toggleGeolocationModal: toggleGeolocationModal,
            }}
          />
        )}
        {!isNotFound && !isNotGeo && (
          <CustomStoreError {...{ storeId: storeId, message: message }} />
        )}
      </>
    )
  }
}

export default StoreErrorPage
